module.exports = __webpack_public_path__ + "static/media/Estampa_Card6.7c4dde03.png";